/**
 * @description 下载海报提供者组件
 * 使用 Portal 渲染隐藏的高分辨率 Poster 供下载使用
 * 通过 Jotai 全局状态控制按需渲染
 */

'use client';

import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import Poster from './base/Poster';
import useShare from '../hooks/useShare';
import { shouldRenderDownloadPosterAtom } from '@/store/referral';

export default function ReferralPosterProvider() {
  const { downloadPosterConfig, setDownloadPosterRef } = useShare({ fetchOnMount: false });
  const [mounted, setMounted] = useState(false);
  const shouldRender = useAtomValue(shouldRenderDownloadPosterAtom);
  // 标记 Poster 是否已创建（一旦创建就保持为 true）
  const [hasCreated, setHasCreated] = useState(false);

  // 确保只在客户端渲染
  useEffect(() => {
    setMounted(true);
  }, []);

  // 监听 shouldRender 变化，一旦为 true 就标记为已创建
  useEffect(() => {
    if (shouldRender && !hasCreated) {
      setHasCreated(true);
    }
  }, [shouldRender, hasCreated]);

  // 服务端渲染时不渲染
  if (!mounted || typeof document === 'undefined') {
    return null;
  }

  // 未创建过且未请求渲染时不渲染
  if (!hasCreated) {
    return null;
  }

  // 数据未准备好时不渲染
  if (!downloadPosterConfig.posterUrl || !downloadPosterConfig.inviteCode) {
    return null;
  }

  return createPortal(
    <div
      className="refer-poster absolute left-0 top-0 overflow-hidden opacity-0 pointer-events-none -z-10"
      style={{
        width: '56.25vw',
        maxHeight: 'calc(100% - 305px)',
        aspectRatio: '9 / 16',
      }}
    >
      <Poster
        ref={(ref) => setDownloadPosterRef(ref)}
        poster={{
          url: downloadPosterConfig.posterUrl,
        }}
        qrcode={{
          url: downloadPosterConfig.shareUrl || '',
          size: 60,
          className: 'w-[100px] h-[100px]',
        }}
        logo={{
          width: 84,
          height: 47,
        }}
        bottom={{
          download: true,
        }}
        className="w-[384px] h-[683px]"
        isThumbnail={false}
        inviteCode={downloadPosterConfig.inviteCode}
      />
    </div>,
    document.body
  );
}
